export default __webpack_public_path__ + "static/media/trending2.3eeed45f.jpg";